'use client'
import React from 'react'

import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import {
  GetTopSellingCampaignProductsQuery,
  GetTopSellingCampaignProductsQueryVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { GET_TOP_SELLING_CAMPAIGN_PRODUCTS } from '@dustin-web/microsite-data/src/graphql/product/get-top-selling-campaign-products.graphql'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import ProductCardGallery from '../cards/product-card-gallery'

export const TopSellingCampaignProducts = () => {
  const { translate } = useTranslations()
  const { data } = useGraphql<
    GetTopSellingCampaignProductsQuery,
    GetTopSellingCampaignProductsQueryVariables
  >(GET_TOP_SELLING_CAMPAIGN_PRODUCTS, {
    variables: {
      numberOfProducts: 12,
    },
  })

  const products = data?.topSellingCampaignProducts?.products
  if (!products) {
    return null
  }

  return (
    <div
      className="c-box c-box--section u-bg-gray-02 u-attach-section"
      data-gasource="CampaignProducts">
      <div className="container">
        <h3>{translate('TopSellingCampaignProducts_Header')}</h3>
        <div className="row sm-gutters">
          {products.map(
            (product, i) =>
              product?.searchResultProduct && (
                <ProductCardGallery
                  ticket={product.ticket}
                  product={product.searchResultProduct}
                  key={i}
                  digitalDataOrigin={'topSellingCampaign'}
                  digitalIndex={i}
                />
              )
          )}
        </div>
      </div>
    </div>
  )
}
